<template>
  <div class="agrial-switch">
    <label
      :class="{active:!value}"
      @click="localValue = false"
    >{{ labelOff }}</label>
    <v-switch
      v-model="localValue"
      flat
      light
      :dense="dense"
      v-bind="$attrs"
      :color="persoColorValid ? 'secondary' : 'grey'"
      class="ml-2 mt-4"
      v-on="$listeners"
    >
      <slot
        v-for="(_, name) in $slots"
        :slot="name"
        :name="name"
      />
      <template
        v-for="(_, name) in $scopedSlots"
        :slot="name"
        slot-scope="slotData"
      >
        <slot
          :name="name"
          v-bind="slotData"
        />
      </template>
    </v-switch>
    <label
      :class="{active:value}"
      @click="localValue = true"
    >{{ labelOn }}</label>
  </div>
</template>
<script>
export default {
  name: 'AgrialSwitch',
  props: {
    labelOn: {
      type: String,
      required: true
    },
    labelOff: {
      type: String,
      default: undefined
    },
    value: {
      type: Boolean,
      default: false
    },
    persoColorValid: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get () { return this.value },
      set (localValue) { this.$emit('input', localValue) }
    }
  }
}
</script>
<style lang="scss" scoped>
.agrial-switch {
  display: flex;
  align-items: center;
  > * {
    flex: 0 1 auto;
  }
  label {
    cursor: pointer;
    &.active {
      font-weight: bold;
    }
  }
}
</style>
